import React, { useEffect, useState, useRef } from "react";
import Switch from "react-switch";
import utils from "../../Utils";
import "./editDoctorProfile.css";
import ReactInputMask from "react-input-mask";
import toast from "react-hot-toast";
import Widgets from "../../Widgets";
import { t } from "../../Utils/translate";
import clinicService from "../../Services/clinicService";
import strings from "../../Utils/strings";
import authService from "../../Services/authService";

function DoctorTiming({ isEditTiming, doctorTiming, onClinicTimingsChange, hospitalTime, setHospitalTime }) {
  const inputTypeFrom = "FROM";
  const inputTypeTo = "TO";
  const [dayList, setDayList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditTimingValue, setIsEditTimingValue] = useState(null);
  const [clinicDetails, setClinicDetails] = useState([]);
  const isFetched = useRef(false);

  useEffect(() => {
    const initializeData = async () => {
      setIsLoading(true);
      try {
        let response;
        if (authService.getIsDoctorLogin() === "true") {
          response = await clinicService.docGetClinicProfile();
        } else {
          response = await clinicService.hospitalProfile();
        }
        if (response) {
          const hospitalTimings = response.data.hospital.openingHoursSpecification;
          setHospitalTime(hospitalTimings);
        }
      } catch (error) {
        console.error("Error fetching hospital timings:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    initializeData();
  }, []);
  
  useEffect(() => {
    if (hospitalTime && hospitalTime.length > 0) {
      setUpDayList();
    }
  }, [hospitalTime, doctorTiming]);
  
  console.log('Line 44',hospitalTime);
  useEffect(() => {
    setUpDayList();
  }, [doctorTiming]);

  useEffect(() => {
    setIsEditTimingValue(isEditTiming ? true : false);
  }, [isEditTiming]);

  useEffect(() => {
    if (!isFetched.current) {
      getClinicProfile();
      isFetched.current = true;
    }
  }, []);

  const getClinicProfile = async () => {
    try {
      let response = await clinicService.hospitalProfile();
      if (response) {
        const hospitalTimings = response.data.hospital.openingHoursSpecification;
        setClinicDetails(hospitalTimings);
      }
    } catch {}
  };

  async function setUpDayList() {
    const emptyDayList = [
      { day: "Monday", displayDay: t("Monday"), status: false, limit: 3, timing: [] },
      { day: "Tuesday", displayDay: t("Tuesday"), status: false, limit: 3, timing: [] },
      { day: "Wednesday", displayDay: t("Wednesday"), status: false, limit: 3, timing: [] },
      { day: "Thursday", displayDay: t("Thursday"), status: false, limit: 3, timing: [] },
      { day: "Friday", displayDay: t("Friday"), status: false, limit: 3, timing: [] },
      { day: "Saturday", displayDay: t("Saturday"), status: false, limit: 3, timing: [] },
      { day: "Sunday", displayDay: t("Sunday"), status: false, limit: 3, timing: [] },
    ];
    const mergedDayList = emptyDayList.map((day) => {
      const hospitalTiming = hospitalTime?.find(
        (hospitalDay) => hospitalDay.dayOfWeek === day.displayDay
      );
      day.isHospitalClosed = !hospitalTiming?.opens || !hospitalTiming?.closes;


      const timingData = doctorTiming.find((timing) => timing.dayOfWeek === day.day);
      if (timingData && timingData.sessions && timingData.sessions.length > 0) {
        day.status = true;
        day.timing = timingData.sessions.map((session) => ({
          from: session.opens,
          to: session.closes,
        }));
      }
      return day;
    });
    setDayList(mergedDayList);
    onClinicTimingsChange(mergedDayList)
  }

  const convertToOpeningHoursSpecification = (openingHours) => {
    const openingHoursSpecification = openingHours.map(({ day, displayDay, status, limit, timing }) => ({
      day,
      displayDay,
      status,
      limit,
      timing: timing.map(({ from, to }) => ({
        from,
        to,
      })),
    }));
    onClinicTimingsChange(openingHoursSpecification);
    // console.log(openingHoursSpecification)
  };

  function onCollisionCheck(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];

    let res = utils.utilFunctions.checkTimeCollision(arr, timeArrIndex, clinicDetails, item.day);
    if (!res.valid) {
      toast.dismiss();
      toast.error(res.error);
      if (inputType === "TO") {
        arr[timeArrIndex] = {
          from: arr[timeArrIndex].from,
          to: "__:__",
        };
      } else if (inputType === "FROM") {
        arr[timeArrIndex] = {
          from: "__:__",
          to: arr[timeArrIndex].to,
        };
      }
      dayListArr[dayArrIndex].timing = arr;
      setDayList(dayListArr);
    } else {
      convertToOpeningHoursSpecification(dayListArr);
    }
  }

  // const checkTimeWithinHospitalHours = (day, fromTime, toTime) => {
  //   const hospitalHours = hospitalTime.find((h) => h.dayOfWeek === day.displayDay);

  //   if (!hospitalHours) {
  //     return { valid: false, message: `${day.displayDay} hospital hours are not set.` };
  //   }

  //   const { opens, closes } = hospitalHours;

  //   const convertToMinutes = (time) => {
  //     const [hours, minutes] = time.split(":").map(Number);
  //     return hours * 60 + minutes;
  //   };

  //   if (!fromTime || !toTime || !fromTime.includes(":") || !toTime.includes(":")) {
  //     return { valid: false, message: `Invalid session entry for ${day.displayDay}.` };
  //   }

  //   const fromInMinutes = convertToMinutes(fromTime);
  //   const toInMinutes = convertToMinutes(toTime);
  //   const opensInMinutes = convertToMinutes(opens);
  //   const closesInMinutes = convertToMinutes(closes);

  //   if (fromInMinutes >= toInMinutes) {
  //     return { valid: false, message: `End time should be after start time for ${day.displayDay}.` };
  //   }

  //   if (fromInMinutes < opensInMinutes || toInMinutes > closesInMinutes) {
  //     return {
  //       valid: false,
  //       message: `The session (${fromTime} - ${toTime}) is outside hospital hours (${opens} - ${closes}) for ${day.displayDay}.`,
  //     };
  //   }

  //   return { valid: true, message: "" };
  // };
  const checkTimeWithinHospitalHours = (day, fromTime, toTime) => {
    const hospitalHours = hospitalTime.find((h) => h.dayOfWeek === day.displayDay);

    const isValidTime = (time) => {
      if (!time || !time.includes(":")) return false;
      const [hours, minutes] = time.split(":").map(Number);
      return (
        Number.isInteger(hours) &&
        Number.isInteger(minutes) &&
        hours >= 0 &&
        hours <= 23 &&
        minutes >= 0 &&
        minutes <= 59
      );
    };

    if (!isValidTime(fromTime) || !isValidTime(toTime)) {
      return { valid: false, message: "Invalid timing session." };
    }

    if (!hospitalHours) {
      return { valid: false, message: `${day.displayDay} hospital hours are not set.` };
    }

    const { opens, closes } = hospitalHours;

    const convertToMinutes = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    };

    const fromInMinutes = convertToMinutes(fromTime);
    const toInMinutes = convertToMinutes(toTime);
    const opensInMinutes = convertToMinutes(opens);
    const closesInMinutes = convertToMinutes(closes);

    if (fromInMinutes >= toInMinutes) {
      return { valid: false, message: `End time should be after start time for ${day.displayDay}.` };
    }

    if (fromInMinutes < opensInMinutes || toInMinutes > closesInMinutes) {
      return {
        valid: false,
        message: `The session (${fromTime} - ${toTime}) is outside hospital hours (${opens} - ${closes}) for ${day.displayDay}.`,
      };
    }

    return { valid: true, message: "" };
  };

  function setInputValue(inputType, value, item, timeArrIndex, dayArrIndex) {
    let dayListArr = [...dayList];
    let arr = [...item.timing];
    if (inputType === strings.addDoctor.label_from) {
      arr[timeArrIndex] = {
        from: value,
        to: arr[timeArrIndex].to,
      };
    } else if (inputType === strings.addDoctor.label_to) {
      arr[timeArrIndex] = {
        from: arr[timeArrIndex].from,
        to: value,
      };
    }
    dayListArr[dayArrIndex].timing = arr;
    setDayList(dayListArr);
  }
  // function handleBlur(inputType, enteredTime, item, timeArrIndex, dayArrIndex) {
  //   const updatedDayList = [...dayList];
  //   const fromTime = item.timing[timeArrIndex].from;
  //   const toTime = item.timing[timeArrIndex].to;

  //   const { valid, message } = checkTimeWithinHospitalHours(item, fromTime, toTime);

  //   if (!valid) {
  //     toast.error(message);

  //     if (inputType === strings.addDoctor.label_from) {
  //       updatedDayList[dayArrIndex].timing[timeArrIndex].from = hospitalTime[dayArrIndex]?.opens || "__:__";
  //     } else if (inputType === strings.addDoctor.label_to) {
  //       updatedDayList[dayArrIndex].timing[timeArrIndex].to = hospitalTime[dayArrIndex]?.closes || "__:__";
  //     }

  //     setDayList(updatedDayList);
  //   } else {
  //     onClinicTimingsChange(updatedDayList);
  //   }
  // }
  function handleBlur(inputType, _enteredTime, item, timeArrIndex, dayArrIndex) {
    const updatedDayList = [...dayList];
    const fromTime = item.timing[timeArrIndex].from;
    const toTime = item.timing[timeArrIndex].to;

    // Check if the entered time is empty or invalid
    const isInvalidTime = (time) => !time || !time.includes(":") || time.split(":").length !== 2;

    if (isInvalidTime(fromTime) || isInvalidTime(toTime)) {
      // Set placeholder HH:MM for empty or invalid input
      if (inputType === strings.addDoctor.label_from) {
        updatedDayList[dayArrIndex].timing[timeArrIndex].from = "HH:MM";
      } else if (inputType === strings.addDoctor.label_to) {
        updatedDayList[dayArrIndex].timing[timeArrIndex].to = "HH:MM";
      }

      setDayList(updatedDayList);
      onClinicTimingsChange(updatedDayList);
      return; // Exit without showing a toast message
    }

    const { valid, message } = checkTimeWithinHospitalHours(item, fromTime, toTime);

    if (!valid) {
      toast.error(message);

      // Reset invalid time to hospital opening/closing time
      if (inputType === strings.addDoctor.label_from) {
        updatedDayList[dayArrIndex].timing[timeArrIndex].from = hospitalTime[dayArrIndex]?.opens || "HH:MM";
      } else if (inputType === strings.addDoctor.label_to) {
        updatedDayList[dayArrIndex].timing[timeArrIndex].to = hospitalTime[dayArrIndex]?.closes || "HH:MM";
      }

      setDayList(updatedDayList);
    } else {
      onClinicTimingsChange(updatedDayList);
    }
  }
  if (!hospitalTime || hospitalTime.length === 0) {
    return <div>{t("No hospital timing data available.")}</div>; 
  }
  if (isEditTimingValue != null) {
    return (
      <div>
        {isLoading ? <Widgets.CircularLoader /> : null}
        <div className="clinic-timing-item-container">
          {dayList.map((item, i) => (
            <div key={i} className="clinic-timing-item-view">
              <div className="clinic-timing-boxes d-flex justify-content-between">
                <span className="week-names">{item.displayDay}</span>
                <Switch
                  onChange={() => {
                    let arr = [...dayList];
                    if (arr[i].isHospitalClosed && arr[i].status) {
                      // If the hospital is closed and the toggle is enabled, disable the toggle
                      arr[i].status = false;
                    } else {
                    arr[i].status = !arr[i].status;
                    if (arr[i].status) {
                      if (i === 0 && arr[i].timing.length === 0) {
                        arr[i].timing.push(utils.constants.timeValue);
                      } else if (dayList[0].status) {
                        arr[i].timing = dayList[0].timing;
                      } else if (arr[i].timing.length === 0) {
                        arr[i].timing.push(utils.constants.timeValue);
                      }
                    } else if (!isEditTimingValue) {
                      arr[i].timing = [];
                    }
    }
                    setDayList(arr);
                  }}
                  checked={item.status}
                  uncheckedIcon={utils.appStyles.switchStyle.uncheckedIcon}
                  checkedIcon={utils.appStyles.switchStyle.checkedIcon}
                  handleDiameter={utils.appStyles.switchStyle.handleDiameter}
                  height={utils.appStyles.switchStyle.height}
                  width={utils.appStyles.switchStyle.width}
                  offHandleColor={utils.appStyles.switchStyle.offHandleColor}
                  onHandleColor={utils.appStyles.switchStyle.onHandleColor}
                  offColor={utils.appStyles.switchStyle.offColor}
                  onColor={utils.appStyles.switchStyle.onColor}
                  activeBoxShadow={utils.appStyles.switchStyle.activeBoxShadow}
                  disabled={isLoading || (item.isHospitalClosed && !item.status)}
                />
              </div>

              {item.status &&
                item.timing.map((item2, i2) => {
                  let showDeleteButton = item.timing.length > 1 && (item.timing.length === 3 || i2 === 1);
                  let fromValue = item2.from;
                  let toValue = item2.to;

                  return (
                    <div key={i2} className="clinic-timing-boxes-2-parent">
                      <div className="clinic-timing-boxes-2 d-flex">
                        <div className="clinic-timing-boxes-2-input-view">
                          <div className="clinic-timing-range-label">{t("labelFrom")}</div>
                     
                          <ReactInputMask
                              placeholder={t("hh_mm")}
                              mask={"99:99"}
                            value={fromValue}
                            onChange={(e) => {
                              setInputValue(strings.addDoctor.label_from, e.target.value, item, i2, i);
                            }}
                            onBlur={(e) => {
                              handleBlur(strings.addDoctor.label_from, e.target.value, item, i2, i);
                            }}
                            className="form-control time-input"
                            disabled={item.isHospitalClosed}
                          />

                        </div>
                        <div className="clinic-timing-boxes-2-input-view">
                          <div className="clinic-timing-range-label">{t("labelTo")}</div>
                          <ReactInputMask
                              placeholder={t("hh_mm")}
                              mask={"99:99"}
                            value={toValue}
                            onChange={(e) => {
                              setInputValue(strings.addDoctor.label_to, e.target.value, item, i2, i);
                            }}
                            onBlur={(e) => {
                              handleBlur(strings.addDoctor.label_to, e.target.value, item, i2, i);
                            }}
                            className="form-control time-input"
                            disabled={item.isHospitalClosed}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
}

export default DoctorTiming;
